import React, { useState, useRef } from 'react';
import { FormGroup, FormControlLabel, checkboxClasses, Checkbox, Box } from '@mui/material';
import Slider from "react-slick";

import MuiButton from '../../../common/muiButton/MuiButton';

import CancelOnboarding from './CancelOnboarding';
import ChangeCompanyName from './ChangeCompanyName';
import DeactivateCompany from './DeactivateCompany';
import CustomButton from '../../../common/CustomButton';

const EditOrganization = ({ organization }) => {
    const sliderRef = useRef(null);
    const [page, setPage] = useState(0);
    const settings = {
        rows: 1,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        swipeToSlide: true,
        swipe: false,
        arrows: false,
        draggable: false,
        initialSlide: page,
        adaptiveHeight: true,
    };
    const SlideTo = (p) => {
        sliderRef?.current?.slickGoTo(p);
    }

    const [selectedOption, setSelectedOption] = useState("");

    // state to change the view when choosing what to Edit
    const [wrapperChanger, setWrapperChanger] = useState('')

    // function to detect which part to edit, wheter 'cancel onboarding' || 'change company name' || deactivate company
    const handleEditCompany = () => {
        SlideTo(1);
    }

    return (
        <div id="edit-org-form">
            <div id="eof-header">
                <h4 className='ta-c'>EDIT COMPANY</h4>
                <p className='ta-c'>
                    {
                        organization?.firstname
                            ? (organization?.firstname + " " + organization?.lastname + " " + (organization?.dob ? ` - DOB: ${organization?.dob}` : ""))
                            : '"No Super User added"'
                    }
                </p>
                <h5>{organization?.name?.toUpperCase()}</h5>
            </div>

            <div className='eof-slick-container'>
                <Slider {...settings} ref={sliderRef}>
                    <div>
                        <div id="option-card-list">
                            <div id="option-card" onClick={() => { setSelectedOption('changeName') }}>
                                <div class={"op-indicator " + (selectedOption == "changeName" ? "selected" : "")}></div>
                                <h5>Change Company Name</h5>
                            </div>

                            <div id="option-card" onClick={() => { setSelectedOption('deactivate') }}>
                                <div class={"op-indicator " + (selectedOption == "deactivate" ? "selected" : "")}></div>
                                <h5>Deactivate Company</h5>
                            </div>
                        </div>

                        <div className='flex-c'>
                            <CustomButton onClick={handleEditCompany} disabled={!selectedOption}>EDIT COMPANY</CustomButton>
                        </div>
                    </div>
                    <div>
                        {
                            selectedOption === 'changeName' &&
                            <ChangeCompanyName organization={organization} setWrapperChanger={(data) => {
                                SlideTo(0);
                            }} />
                        }
                        {
                            selectedOption === 'deactivate' &&
                            <DeactivateCompany organization={organization} setWrapperChanger={(data) => {
                                SlideTo(0);
                            }} />
                        }
                    </div>
                </Slider>
            </div>
        </div>
    );
};

export default EditOrganization;